import { render, staticRenderFns } from "./SimpleTableBoolean.vue?vue&type=template&id=376a24ea&lang=html&functional=true&"
import script from "./SimpleTableBoolean.vue?vue&type=script&lang=js&"
export * from "./SimpleTableBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports